import { render } from "./VideoPlayer.vue?vue&type=template&id=df83ace4&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=df83ace4&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df83ace4"]])

export default __exports__